<template>
    <div style="width: 100%;">
        <!-- 图标 -->
        <el-row style="padding-top: 10px;">
            <el-col :span="24" style="text-align: center; min-height: 80px;">
                <div v-show="sidebarImg">
                    <img :src="sidebarImgSrc" id="sidebarImg">
                </div>
            </el-col>
        </el-row>

        <!-- 标题 -->
        <el-row style="padding: 0 0 10px 0;">
            <el-col :span="16" :offset="4" style="text-align: center; font-size: 17px;">
                <span style="color: #FFFFFF;">分发中心</span>
            </el-col>
        </el-row>

        <!-- 菜单 -->
        <el-menu class="el-menu-vertical"
                    background-color="#33363c"
                    text-color="#fff"
                    :collapse="isCollapse"
                    :unique-opened = true
                    :default-active = "this.$route.name"
                    :router = true
                    :collapse-transition=false
                    >
            <!-- 单个子菜单 -->
            <el-menu-item v-for="item in menuRouters"
                          v-if="item.children.length===1 && !item.children[0].children"
                          :route="{name:item.children[0].name}"
                          :key="item.children[0].name"
                          :index="item.children[0].name"
                          @click.native="refreshView()"
                          >
                <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
                <span v-if="item.children[0].meta&&item.children[0].meta.title">{{item.children[0].meta.title}}</span>

            </el-menu-item>


            <!-- 多个子菜单 -->
            <el-submenu v-for="item in menuRouters"
                        v-if="item.children.length > 1 && !item.children[0].children"
                        :index="item.name"
                        :key="item.name"
                        >
                <template slot="title">
                    <svg-icon v-if="item.meta && item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
                    <span v-if="item.meta && item.meta.title">{{item.meta.title}}</span>
                </template>

                <el-menu-item v-for="child in item.children"
                            v-if="!child.hidden"
                            :route="{name: child.name}"
                            :index="child.name"
                            :key="child.name"
                            @click.native="refreshView()"
                            >
                    <span v-if="child.meta && child.meta.title">{{child.meta.title}}</span>
                </el-menu-item>

            </el-submenu>

        </el-menu>
    </div>
</template>

<script>
    export default{
        name: "sidebar",
        data(){
            return {
            	menuRouters: this.$store.getters.routers,
                isCollapse: false,
                sidebarImg: true,
                sidebarImgSrc: require("@/assets/icon/sidebar/center.png")
            }
        },
	    inject:['routerViewReload'],
        methods: {
	        /**
             * 收缩状态切换，图片展示切换。
	         */
	        stateToggle(){
                this.isCollapse = !this.isCollapse;
                this.isCollapse ? this.sidebarImg = false : this.sidebarImg = true;
            },

	        /**
             * 调用父类的刷新route-view
	         */
	        refreshView(){
            	this.routerViewReload();
            }
        },
  }
</script>

<style scoped>
    #sidebarImg{
        width: 80px;
        height: 80px;
    }
    .el-menu-vertical:not(.el-menu--collapse) {
      width: calc(11vw - 5px);
      min-height: 400px;
    }
    .el-menu-vertical i{
      color: #ffffff;
    }
    .el-menu{
      border-right: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue